// extracted by mini-css-extract-plugin
export default {"wrapper":"navigation_wrapper__6pjg3"};